import RequestAbstract from '../abstract';

export default class AccountingValidationTasks extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/accounting-validation-tasks';
    }
}
